export const interests = [
  "business",
  "psychology",
  "philosophy",
  "work",
  "money",
  "future",
  "technology",
  "travel",
  "programming",
  "startup",
  "cybersecurity",
  "writing",
  "literature",
  "art",
  "design",
  "photography",
  "music",
];
